<template>
  <div class="wait-confirm-bill">
    <div>
      <!-- 表格-->
      <el-table
        :loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :max-height="300"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="serialNum"
          label="序号"
        >
        </el-table-column>
        <el-table-column
          prop="pushTime"
          label="结算单推送日期"
        >
        </el-table-column>
        <el-table-column
          prop="purchaseCorpName"
          label="采购公司"
        >
        </el-table-column>
        <el-table-column
          prop="settleNo"
          label="结算单号"
        >
          <template slot-scope="scope">
            <span class="blue" @click="loadAccountDetail(scope.row.settleNo)">{{scope.row.settleNo}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="settleDate"
          label="结算单生成日期"
        >
        </el-table-column>
        <el-table-column
          prop="purchaseTotalAmount"
          label="采购总金额"
        >
        </el-table-column>
        <el-table-column
          prop="refundTotalAmount"
          label="退货总金额"
        >
        </el-table-column>
        <el-table-column
          prop="unSettleTotalAmount"
          label="待结算总金额"
        >
        </el-table-column>
        <el-table-column
          prop="settleStatus"
          label="结算单状态"
        >
          <template slot-scope="scope">
            <span>{{scope.row.settleStatus | filterSettleStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small">
              申诉中
            </el-button>
            <el-button
              @click.native.prevent="confirmbtn"
              type="text"
              size="small">
              确认
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100, 200]"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <!-- 账单详情表格-->
    <detail-table ref="detailTable"/>
  </div>
</template>

<script>
import DetailTable from "./detailTable";
export default {
  props: {
    tableData: Array,
    loading: Boolean,
    handleSizeChange: Function,
    handleCurrentChange: Function,
    currentPage: Number,
    pageSize: Number,
    totalCount: Number,
    handleSelectionChange: Function
  },
  data() {
    return {
      detailLoading: false,
      detailData: [],
      orderDialogVisible: false,
      billConfirmDialog: false,
      appealBillDialog: false,
    }
  },
  components: {
    DetailTable
  },
  filters: {
    filterSettleStatus(type) {
      console.log(type, "type");
      let text = "";
      switch (type) {
        case 1:
          text = "新建";
          break;
        case 2:
          text = "已支付";
          break;
        case -1:
          text = "取消";
          break;
        case 3:
          text = "已审核";
          break;
        case 4:
          text = "申诉中";
          break;
        case 5:
          text = "已确认";
          break;
        case 6:
          text = "已推送";
          break;
        case 7:
          text = "推送失败";
          break;
      }
      return text;
    }
  },
  methods: {
    loadAccountDetail(settleNo) {
      this.$refs.detailTable.loadAccountDetail(settleNo);
    },
    confirmbtn() {
      this.$message('您的账单已申请，业务同事会线下 与您沟通');
    },
    clearDetail() {
      this.$refs.detailTable.detailData = [];
    },
    handleClose() {

    }
  }
}
</script>
<style lang="scss" scoped>
.wait-confirm-bill {
  .detail-title {
    font-size: 12px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    margin-bottom: 6px;
  }
  .blue {
    color: #236BDC;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/r4SettlementReport/billConfirm/components/appealConfirmBill.vue